module.exports = __webpack_public_path__ + "static/media/digisence-logo-no-bg.62aab77f.png";